import {columns} from "./columns"
import {DataTable} from "./data-table"
import {useEffect, useState} from "react";
import axios from "axios";
import Skeleton from "@/pages/Skeleton.tsx";
import {Company} from "@/types/Company";
import usePermission from "@/components/permissions/usePermission.ts";
import {keycloakAdminApi, keycloakApi} from "@/main.tsx";
import {User} from "@/pages/settings/Users.tsx";
import {useAuth} from "react-oidc-context";

export type CompanyRepresentation = {
    id: string,
    name: string,
    registration_number: string,
    tax_number: string,
    data: Company,
    created_at: string,
    updated_at: string,
    user: string | {
        name: string,
        email: string,
        id: string
    }
}
export type LaravelResponse<T> = {
    data: T,
    current_page: number,
    first_page_url: string,
    from: number,
    last_page: number,
    last_page_url: string,
    per_page: number,
    total: number
    to: number
}

export default function CompaniesPage() {
    const [data, setData] = useState<CompanyRepresentation[]>()
    const admin = usePermission("user.any")[1]
    const auth = useAuth()

    useEffect(() => {
        (async () => {
            let users
            if (admin) {
                users = (await keycloakAdminApi.get<Array<User>>("/users")).data
            } else {
                users = [(await keycloakApi.get<User>("/account")).data]
            }
            //console.log(users)
            axios.get<LaravelResponse<Array<CompanyRepresentation>>>(`/api/company`).then(res => {
                const processedData = res.data.data.map((x) => {
                    const user = users.find((user) => user.id == x.user)
                    if (user) {
                        x.user = {name: user.firstName + " " + user.lastName, email: user.email, id: user.id}
                    } else {
                        x.user = {name: "", email: "", id: ""}
                    }
                    return x
                })
                setData(processedData)
            })
        })()
    }, [admin]);


    if (data)
        return (
            <div className="container mx-auto p-4">
                <DataTable columns={columns(auth)} data={data}/>
            </div>
        )
    else return (
        <Skeleton/>
    )
}